import { Block } from 'ui-kit/blocks'
import { Text, Heading } from 'ui-kit/typography'
import { Picture } from 'ui-kit/picture'
import { aboutUsMissionData } from './aboutUsMissionData'
import { AboutUsMissionCard } from './AboutUsMissionCard'
import SignatureIcon from './about-us-icon.svg'
import MissionAppImage1x from './about-us-app@1x.png'
import MissionAppImage2x from './about-us-app@2x.png'
import classes from './AboutUsMission.module.scss'

export const AboutUsMission = () => {
  return (
    <Block
      as={'section'}
      variant={'shadowMob'}
      pad={'content'}
      divider={'mobile'}
      className={classes.section}
    >
      <div className={classes.heading}>
        <Text center balance className={classes.subtitle}>
          For years, this deep connecting tissue between SaaS apps has been
          missing.
        </Text>
        <Text center balance className={classes.subtitle}>
          We are building it now.
        </Text>
      </div>
      <Heading as={'h2'} size={'xl'} center>
        Our mission
      </Heading>
      <div className={classes.stroke} />

      <div className={classes.content}>
        {aboutUsMissionData.map(
          ({ items }: { items: Record<string, string>[] }, idx) => (
            <ul className={classes.list} key={idx}>
              {items.map((item, idx) => (
                <AboutUsMissionCard key={idx} item={item} />
              ))}
            </ul>
          ),
        )}
        <img src={SignatureIcon.src} alt='Signature' className={classes.icon} />
      </div>
      <Block className={classes.visual}>
        <Picture
          className={classes.image}
          src1x={MissionAppImage1x.src}
          src2x={MissionAppImage2x.src}
          deskBreakpoint='1000px'
          width={1180}
          height={461}
          alt='Integration App'
          fetchPriorityHigh
        />
      </Block>
    </Block>
  )
}
